type CreateSenderIconUrlProps = {
    size?: number;
    id: string | null;
    type?: 0 | 1;
};

/**
 * createSenderIconUrl
 * generate the sender icon url for an image stored in e-boks classic
 * @format https://m.e-boks.dk/app/image2.ashx?cvr=66137112&width=48&height=48&type=1
 */
export const createSenderIconUrl = ({ id, size = 42, type = 1 }: CreateSenderIconUrlProps): string => {
    return id !== null && id?.length === 8
        ? `https://m.e-boks.dk/app/image2.ashx?cvr=${id}&width=${size}&height=${size}&type=${type}`
        : '';
};
